import React from 'react';
import { truncate } from 'lodash';

import TickerUnfoundSymbols from 'buyside/components/presentation/TickerUploader/tickerUnfoundSymbols';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import { isEmpty } from 'buyside/util/lodashAlt';

import { MassTickerSearchQuery } from 'interfaces/graphql-typings';

import styles from 'buyside/components/presentation/TickerUploader/tickerUploadStyles.scss';

const TickerPostUpload: React.FC<{
  foundEntities: NonNullable<MassTickerSearchQuery['massTickerSearch']>['foundEntities'];
  page: number;
  pageSize: number;
  setPage: (page: number) => void;
  unfoundSymbols: NonNullable<MassTickerSearchQuery['massTickerSearch']>['unfoundSymbols'];
}> = ({ foundEntities, page, pageSize, setPage, unfoundSymbols }): React.ReactElement | null => {
  return (
    <>
      {!isEmpty(unfoundSymbols) && <TickerUnfoundSymbols unfoundSymbols={unfoundSymbols} />}
      <div className={styles.symbolInfo}>
        The following {foundEntities.length > 1 ? <strong>{foundEntities.length} </strong> : ''}
        {foundEntities.length === 1 ? 'entity' : 'entities'} related to your uploaded tickers will
        be added to your watchlist:
      </div>
      <div className={styles.uploadedEntitiesNavigation}>
        <Button
          disabled={page === 0}
          onClick={(): void => setPage(page - 1)}
          type={BUTTON_TYPES.LINK}
          text="Previous Page"
        />
        <Button
          disabled={page === Math.ceil(foundEntities.length / pageSize)}
          className={styles.nextPage}
          onClick={(): void => setPage(page + 1)}
          text="Next Page"
          type={BUTTON_TYPES.LINK}
        />
      </div>
      <div className={styles.foundSymbols}>
        {foundEntities.slice(page * pageSize, page * pageSize + pageSize).map(
          (entity): React.ReactElement => (
            <span className={styles.entity} key={entity.id}>
              <strong>{entity.primarySymbol}</strong>
              {entity?.name && ` - ${truncate(entity.name.toUpperCase(), { length: 20 })}`}
            </span>
          )
        )}
      </div>
      <div className={styles.note}>
        Note: More entities than tickers may appear above due to M & A.
      </div>
    </>
  );
};
export default TickerPostUpload;
